export const filterMetricsLocations = (metricLocationIds, userLocations) =>
  metricLocationIds && metricLocationIds.reduce((previousLocations, locationId) => {
    const location = userLocations.find(({ id }) => parseInt(id) === parseInt(locationId));

    return location ? [...previousLocations, location] : previousLocations;
  }, []);